import { Phone, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';
import { motion } from 'framer-motion';

export const CTA = ({ onBookClick }) => {
  const handleBookAppointment = () => {
    if (onBookClick) {
      onBookClick();
    } else {
      window.location.href = 'tel:+919986671810';
    }
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/919986671810?text=Hello! I would like to book an appointment at AyurvedMed Healthcare.', '_blank');
  };

  return (
    <section
      data-testid="cta-section"
      className="section-padding relative overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #2D4A3E 0%, #1e3329 100%)'
      }}
    >
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none">
          <pattern id="cta-pattern" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
            <circle cx="10" cy="10" r="1" fill="white" />
          </pattern>
          <rect x="0" y="0" width="100" height="100" fill="url(#cta-pattern)" />
        </svg>
      </div>

      <div className="section-container relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-sm tracking-widest uppercase font-semibold text-[#C67D63] mb-4 block"
          >
            Begin Your Journey
          </motion.span>

          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="heading-2 text-white mb-6"
            data-testid="cta-heading"
          >
            Start Your Healing Journey Today
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="body-large text-white/70 mb-10"
          >
            Take the first step towards holistic wellness. Our experienced Ayurvedic
            physicians are ready to guide you on your path to optimal health.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
            className="flex flex-col sm:flex-row gap-4 justify-center"
          >
            <Button
              onClick={handleBookAppointment}
              data-testid="cta-book-btn"
              className="bg-white text-[#2D4A3E] hover:bg-[#F5F2EB] px-8 py-4 rounded-full flex items-center justify-center gap-2 text-lg font-medium shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <Phone className="w-5 h-5" />
              Book Appointment
            </Button>

            <Button
              onClick={handleWhatsApp}
              data-testid="cta-whatsapp-btn"
              className="bg-[#25D366] text-white hover:bg-[#1da851] px-8 py-4 rounded-full flex items-center justify-center gap-2 text-lg font-medium shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <MessageCircle className="w-5 h-5" />
              WhatsApp Us
            </Button>
          </motion.div>

          {/* Trust Indicators */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4 }}
            className="flex flex-wrap justify-center gap-8 mt-12 pt-8 border-t border-white/10"
          >
            <div className="text-center">
              <p className="text-2xl font-semibold text-white">Free</p>
              <p className="text-sm text-white/60">Initial Consultation</p>
            </div>
            <div className="text-center">
              <p className="text-2xl font-semibold text-white">Same Day</p>
              <p className="text-sm text-white/60">Appointments Available</p>
            </div>
            <div className="text-center">
              <p className="text-2xl font-semibold text-white">100%</p>
              <p className="text-sm text-white/60">Natural Treatments</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
